import { render, staticRenderFns } from "./applylist.vue?vue&type=template&id=8ab27e54&scoped=true"
import script from "./applylist.vue?vue&type=script&lang=js"
export * from "./applylist.vue?vue&type=script&lang=js"
import style0 from "./applylist.vue?vue&type=style&index=0&id=8ab27e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab27e54",
  null
  
)

export default component.exports